import React, { FC, useEffect, useState } from 'react';
import { observer } from 'mobx-react';
import styled from 'styled-components';
import Grid from 'components/UI/Grid';
import api from 'Api/ApiMethods';
import { NotificationTemplate } from 'models/restTypes';
import NotificationTemplateTextTable from './NotificationTemplateTextTable';

const Container = styled(Grid)`
  height: 100%;
  width: 100%;
  justify-content: flex-start;
`;

const NotificationTemplateText: FC = observer(() => {
  const [data, setData] = useState<NotificationTemplate[]>([]);
  const [loading, setLoading] = useState<boolean>(false);

  useEffect(() => {
    setLoading(true);
    api
      .getNotificationTemplates()
      .then((response) => {
        setData(response);
      })
      .finally(() => {
        setLoading(false);
      });
  }, []);

  return (
    <Container>
      <NotificationTemplateTextTable templates={data} isLoading={loading} />
    </Container>
  );
});

export default NotificationTemplateText;
